import log from "loglevel";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { AboutPage } from "@/components/pages/about/AboutPage";

export default AboutPage;

export const getStaticProps: GetStaticProps = async context => {
  try {
    return {
      props: {
        ...(await serverSideTranslations(context.locale as string, [
          "common",
          "homepage",
          "more-drawer",
          "about"
        ]))
      }
    };
  } catch (e) {
    log.error("%0", e);

    return {
      props: {
        notFound: true
      }
    };
  }
};
